import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from '../data.service';
import { ActivatedRoute } from "@angular/router";
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-editarusuario',
  templateUrl: './editarusuario.component.html',
  styleUrl: './editarusuario.component.css'
})
export class EditarusuarioComponent implements OnInit {
  usuarioForm: FormGroup;
  @Input() IdEncuesta: string | null = null; 
  @Input() IdUsuario: string | null = null; 
  @Input() Usuario: any; 
  @Output() edicionFinalizada = new EventEmitter<void>();

  constructor(private fb: FormBuilder, private data: DataService, private route: ActivatedRoute, private messageService: MessageService) {
    this.usuarioForm = this.fb.group({
      Email: ['', [Validators.required]],
      Nombre: ['', [Validators.required]],
      Crear: [true, [Validators.required]],
      Eliminar: [false, [Validators.required]],
      Editar: [false, [Validators.required]],
      Ver: [false, [Validators.required]]
    });

    


  }

  ngOnInit() {

    this.usuarioForm.patchValue({
      Email: this.Usuario['Email'],
      Nombre: this.Usuario['Nombre'],
      Crear: this.Usuario['Crear'],
      Eliminar: this.Usuario['Eliminar'],
      Editar: this.Usuario['Editar'],
      Ver: this.Usuario['Ver']
    });

    //alert(JSON.stringify(this.Usuario));
  }

  async onSubmit() {
    if (this.usuarioForm.valid) {
      //agregar a this.encuestaForm.value los campos FechaCrea, UsuarioCrea, Formulario
      this.usuarioForm.value.FechaModifica = new Date();
      this.usuarioForm.value._id = this.IdUsuario;
      this.usuarioForm.value.IdEncuesta = this.IdEncuesta;

      this.data.EditarUsuario(this.usuarioForm.value).subscribe(response => {
        console.log(response);
        this.messageService.add({severity:'success', summary: 'Éxito', detail: 'Usuario guardado exitosamente'});
        this.cancelaredicion();
        this.IdEncuesta=response.id;
      }, error => {
        console.error('Error al crear la encuesta:', error);
        console.log(error);
        this.messageService.add({severity:'error', summary: 'Error', detail: 'Error al crear la encuesta. Inténtelo nuevamente.'});
      });
    } else {
      console.log('Formulario no válido');
    }
  }

  cancelaredicion(){
    console.log('cancelar edición');
    this.edicionFinalizada.emit();
  }

  get controls() {
    return this.usuarioForm.controls;
  }

}
